export function itemCodeToUrlSlug(itemCode: string): string {
    return itemCode.replaceAll("/", "_").replaceAll(" ", "+");
}

export function updateURLParameters(
    url: string,
    params: Array<{ param: string; value: string }>,
): void {
    if (!Array.isArray(params)) {
        console.warn("updateURLParameters(...): invalid params");
        return;
    }
    const iQueryStart = url.indexOf("?");
    if (iQueryStart < 0) {
        const queries = [];
        for (const p of params) {
            if (typeof p.value === "string" && p.value.length > 0) {
                queries.push(
                    encodeURIComponent(p.param) +
                        "=" +
                        encodeURIComponent(p.value),
                );
            }
        }
        url += "?" + queries.join("&");
    } else {
        const baseUrl = url.substr(0, iQueryStart);
        let queryStr = url.substr(iQueryStart + 1);
        const queries: Array<{ param: string; value: string }> = queryStr
            .split("&")
            .map((qstr) => {
                const qParts = qstr.split("=");
                if (qParts.length > 1) {
                    return {
                        param: qParts[0],
                        value: qParts[1],
                    };
                }
                return {
                    param: qParts[0],
                    value: "",
                };
            });
        // console.log( 'before:', baseUrl, queryStr, queries );
        for (const p of params) {
            const indexParam = queries.findIndex((q) => q.param === p.param);
            if (indexParam >= 0) {
                queries[indexParam].value = encodeURIComponent(p.value);
            } else {
                queries.push({
                    param: encodeURIComponent(p.param),
                    value: encodeURIComponent(p.value),
                });
            }
        }
        queryStr = queries
            .filter((q) => q.value.length > 0)
            .map((q) => q.param + "=" + q.value)
            .join("&");
        // console.log( 'after: ', baseUrl, queryStr );

        url = baseUrl + "?" + queryStr;
    }

    window.history.pushState("", document.title, url);
}
